import { RegFieldConfig } from './../../models/field.interface';
import {
	ComponentFactoryResolver,
	ComponentRef,
	Directive,
	Input,
	OnInit,
	ViewContainerRef,
	EventEmitter,
	Output
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { InputComponent } from '../input/input.component';
import { ButtonComponent } from '../button/button.component';
import { SelectComponent } from '../select/select.component';
import { DateComponent } from '../date/date.component';
import { RadiobuttonComponent } from '../radiobutton/radiobutton.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { FieldConfig } from '../../models/field.interface';

const componentMapper = {
	input: InputComponent,
	button: ButtonComponent,
	select: SelectComponent,
	date: DateComponent,
	radiobutton: RadiobuttonComponent,
	checkbox: CheckboxComponent
};

@Directive({
	selector: '[mrsoftappsDynamicFlatField]'
})
export class DynamicFlatFieldDirective {
	@Input() field: FieldConfig;
	@Input() group: FormGroup;

	componentRef: any;
	constructor(private resolver: ComponentFactoryResolver, private container: ViewContainerRef) {}
	ngOnInit() {
		// console.log(this.field);
		const factory = this.resolver.resolveComponentFactory(componentMapper[this.field.type]);
		this.componentRef = this.container.createComponent(factory);
		this.componentRef.instance.field = this.field;
		this.componentRef.instance.group = this.group;
	}
}
